<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card grid-list-md>
      <ModelTitle title="Assign Teacher To Room" @close="close()" />
      <v-card-text v-if="selectedClassRoom">
        <v-row>
          <v-col cols="12" sm="12">
            <v-col cols="12" sm="12">
              <div>
                Class:
                <span class="font-weight-bold text-capitalize">{{
                    selectedClassRoom.Class.name
                }}</span>
              </div>
              <div>
                Room Name:
                <span class="font-weight-bold text-capitalize">{{
                    selectedClassRoom.name
                }}</span>
              </div>
            </v-col>
          </v-col>

          <!-- <v-col cols="12" sm="12">
            <v-autocomplete
              dense
              autofocus
              hide-details
              :items="Teachers"
              clearable
              item-text="name"
              v-model="selectedTeacher"
              return-object
              label="Select Teacher"
              outlined
              ><template slot="item" slot-scope="{ item }">
                <span>{{ item.name }}</span>
                <v-spacer></v-spacer>
                <v-chip color="grey lighten-3">
                  <v-avatar left class="grey lighten-2">
                    <v-icon small>mdi-account-school-outline</v-icon>
                  </v-avatar>
                  <span>{{ item.studentCount }}</span>
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col> -->

          <v-col cols="12" sm="10">
            <v-autocomplete dense autofocus hide-details :items="Teachers" clearable item-text="name"
              v-model="selectedTeacher" return-object label="Teacher" outlined><template slot="item"
                slot-scope="{ item }">
                <span>{{ item.name }}</span>
                <v-spacer></v-spacer>
                <v-chip color="grey lighten-3">
                  <v-avatar left class="grey lighten-2">
                    <v-icon small>mdi-account-school-outline</v-icon>
                  </v-avatar>
                  <span>{{ item.studentCount }}</span>
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn @click="addTeacher" :disabled="!selectedTeacher" color="success">Add</v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-list class="list-350">
          <template v-for="(row, index) in TeacherList">
            <v-list-item :key="index" v-if="row.Teacher">
              <v-list-item-avatar>
                <v-btn icon>
                  <v-icon color="red" @click="deleteRow(row)">delete</v-icon>
                </v-btn>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-capitalize">{{
                    row.Teacher.name
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <!-- <v-btn color="green lighten-1" :loading="loading" dark @click="submit()"
          >save</v-btn
        > -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import teacherService from "@/modules/Teacher/service.js";
import classesService from "@/modules/ClassRoom/service.js";

export default {
  props: {
    editDialog: {
      default: false,
    },
    editTeacher: {
      type: Object,
    },
    selectedClassRoom: {
      type: Object,
    },
  },
  name: "assign-teacher-class",
  data() {
    return {
      TeacherList: [],
      Teachers: [],
      selectedTeacher: null,
      loading: false,
      dialog: false,
      Teacher: null,
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
  },
  watch: {
    editDialog(val) {
      this.Teacher = this.editTeacher;
      this.dialog = val;
    },
    dialog(val) {
      if (val) {
        this.getTeachers();
        this.getAssTeacherList();
      }
    },
  },
  methods: {
    deleteRow(row) {
      console.log("row", row);
      this.$swal({
        title: "Are you sure?",
        html: `<p>You want to remove <b>${row.Teacher.name}</b> from <b>${this.selectedClassRoom.name}</b> class</p>`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          if (row) {
            classesService
              .removeTeacher(row.id)
              .then((response) => {
                console.log('response', response)
                if (response.data) {
                  const teacherId = (element) => element.id === row.id;

                  let i = this.TeacherList.findIndex(teacherId);
                  this.TeacherList.splice(i, 1);
                  this.$swal(
                    "Remove!",
                    "Teacher has been remove from this teacher.",
                    "success"
                  );
                  // this.getList();
                }
              });
          }
        }
      });
    },
    async addTeacher() {
      console.log("test", this.selectedTeacher);

      let found = false;
      await Promise.all(
        this.TeacherList.map((teacher) => {
          if (teacher.id === this.selectedTeacher.id) found = true;
        })
      );
      if (!found) {
        // this.students.push({id: this.selectedStudent.id})
        let obj = {
          TeacherId: this.selectedTeacher.id,
          ClassRoomId: this.selectedClassRoom.id,
        };
        console.log("obj", obj);
        classesService
          .assignTeacher(obj)
          .then((result) => {
            this.TeacherList.push(result.data);
            console.log("TeacherListTeacherList", this.TeacherList);
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      } else {
        this.$swal({
          title: "Already exist!",
          text: `${this.selectedTeacher.name} is already in this list`,
          icon: "warning",
        });
      }

      this.selectedTeacher = null;
    },
    getAssTeacherList() {
      return classesService
        .getAssignTeacherList({ ClassRoomId: this.selectedClassRoom.id })
        .then((response) => {
          console.log("response", response);
          this.TeacherList = response.data;
          return response;
        });
    },
    getTeachers() {
      return teacherService.getAll().then((response) => {
        console.log("response Teacher", response.data);
        this.Teachers = response.data;
        // this.TeacherList = this.Teacher.Students;
        return response;
      });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Teacher = {
        name: null,
      };
    },
  },
};
</script>

<style scoped>
</style>
